import { render, staticRenderFns } from "./ValidOwnerRequest.vue?vue&type=template&id=5de22514&scoped=true"
import script from "./ValidOwnerRequest.vue?vue&type=script&lang=js"
export * from "./ValidOwnerRequest.vue?vue&type=script&lang=js"
import style0 from "./ValidOwnerRequest.vue?vue&type=style&index=0&id=5de22514&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de22514",
  null
  
)

export default component.exports